import { render, staticRenderFns } from "./IconCalculatorSolid.vue?vue&type=template&id=07346522"
import script from "./IconCalculatorSolid.vue?vue&type=script&lang=js"
export * from "./IconCalculatorSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports